import { API_BASE_URL } from './api'

export function resolveMediaUrl(url?: string | null): string | null {
  if (!url) return null
  if (url.startsWith('/api/')) return API_BASE_URL ? `${API_BASE_URL}${url}` : url
  return url
}
